import { useEffect, useRef } from "react";
import { Box } from "@mui/system";
import Panzoom from "@panzoom/panzoom";

export const ImageView = ({ fileUrl }: { fileUrl: string }) => {
	const imgRef = useRef<HTMLImageElement>(null);

	useEffect(() => {
		const img = imgRef.current;
		if (!img) return;
		const pz = Panzoom(img, {
			maxScale: 10,
			step: 0.5,
			contain: "outside",
		});
		const parent = img.parentElement;
		parent?.addEventListener("wheel", pz.zoomWithWheel);
		return () => {
			pz.destroy();
			parent?.removeEventListener("wheel", pz.zoomWithWheel);
		};
	}, [fileUrl]);

	return (
		<Box
			sx={{
				flex: 1,
				minHeight: 0,
				overflow: "hidden",
				position: "relative",
			}}
		>
			<img
				key={fileUrl}
				ref={imgRef}
				src={fileUrl}
				style={{
					position: "absolute",
					inset: 0,
					width: "100%",
					height: "100%",
					objectFit: "contain",
				}}
			/>
		</Box>
	);
};
